import { useState } from "react";
import Twitter from "../../../assets/images/twitter-gray.png";
import Dribble from "../../../assets/images/dribble.png";
import Behance from "../../../assets/images/behance.png";
import Pinterest from "../../../assets/images/pinterest.png";
import Mail from "../../../assets/images/mailopen.png";
import Phone from "../../../assets/images/phone-call.png";

import { contactService } from "./contactus.service";
import { ContactFormData } from "./contact.types";

const ContactUs = () => {
  const [form, setForm] = useState(new ContactFormData());
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null); // success / error message

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);

    const result = await contactService.submitForm(form);

    setLoading(false);

    if (result.status) {
      setMsg({ type: "success", text: result.data.message });
      setForm(new ContactFormData()); // reset form
    } else {
      setMsg({ type: "error", text: result.data.error });
    }
  };

  return (
    <section className="w-full bg-white py-20 scroll-mt-[90px] max-xl:px-20">
      <div className="max-w-[1150px] mx-auto px-6 lg:px-0 grid lg:grid-cols-2 gap-12 p-10 rounded-xl">

        {/* LEFT SIDE */}
        <div>
          <h2 className="text-[32px] md:text-[36px] font-semibold text-gray-900 mb-3">
            We’d Love To Help
          </h2>

          <p className="text-gray-600 max-w-[360px] leading-relaxed mb-6">
            Book your pick-up, sit back, and let our trusted partners take care of your clothes.
          </p>

          <div className="flex items-center gap-4 mt-4">
            {[Twitter, Dribble, Behance, Pinterest].map((icon, i) => (
              <div
                key={i}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full"
              >
                <img src={icon} alt="Social Icon" className="object-contain w-5 h-5" />
              </div>
            ))}
          </div>

          {/* Contact Details */}
          <div className="mt-10 space-y-6">
            <a href="mailto:saaflo@gmail.com" className="flex items-start gap-4 cursor-pointer">
              <div className="w-12 h-12 bg-[#6a0dad] rounded-full flex items-center justify-center">
                <img src={Mail} alt="Mail Icon" className="object-contain w-6 h-6" />
              </div>
              <p className="text-[16px] font-medium mt-2 text-gray-700">saaflo@gmail.com</p>
            </a>

            <a href="tel:+91 88709 41256" className="flex items-start gap-4 cursor-pointer">
              <div className="w-12 h-12 bg-[#6a0dad] rounded-full flex items-center justify-center">
                <img src={Phone} alt="Phone Icon" className="object-contain w-6 h-6" />
              </div>
              <p className="text-[16px] font-medium mt-2 text-gray-700">+91 88709 41256</p>
            </a>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div>
          <h2 className="text-[32px] md:text-[36px] font-semibold text-gray-900 mb-3">
            Drop Us A Line
          </h2>

          <p className="text-gray-600 max-w-[480px] leading-relaxed mb-6">
            Connect with Us to Embark on a Journey to Create Your Dream Glamping Experience
          </p>

          <form className="space-y-6" onSubmit={handleSubmit}>

            {/* Name + Email */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div className="flex flex-col">
                <label className="text-gray-700 mb-1 text-[15px]">Name</label>
                <input
                  type="text"
                  placeholder="Name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="px-4 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-[#6a0dad]"
                  required
                />
              </div>

              <div className="flex flex-col">
                <label className="text-gray-700 mb-1 text-[15px]">Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="px-4 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-[#6a0dad]"
                  required
                />
              </div>
            </div>

            {/* Message */}
            <div>
              <label className="text-gray-700 mb-1 text-[15px]">Message</label>
              <textarea
                rows={5}
                placeholder="Message content..."
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-md outline-none resize-none focus:ring-2 focus:ring-[#6a0dad]"
                required
              ></textarea>
            </div>

            {/* SUCCESS / ERROR MESSAGE */}
            {msg && (
              <p className={`text-sm ${msg.type === "success" ? "text-green-600" : "text-red-600"}`}>
                {msg.text}
              </p>
            )}

            {/* Button */}
            <button
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold tracking-wide text-white bg-[#6a0dad] rounded-md hover:bg-[#5b0cbc] disabled:opacity-60"
            >
              {loading ? "Sending..." : "SEND MESSAGE"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
